import { Component, inject, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { Router, RouterLink } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { tablerCreditCard, tablerLogout, tablerMoon, tablerSettings, tablerSun, tablerUser } from '@ng-icons/tabler-icons';
import { StoreResetService } from '@store/store-reset.util';
import { AuthStore } from '@store/auth.facade';
import { ThemeService } from '@services/theme.service';
import { getInitials } from '@shared/functions';

@Component({
  selector: 'app-header',
  imports: [TranslocoModule, NgIcon, RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  providers: [
    provideIcons({
      tablerSun,
      tablerMoon,
      tablerSettings,
      tablerLogout,
      tablerUser,
      tablerCreditCard,
    }),
  ],
})
export class HeaderComponent {

  @Input() name = '';
  @Input() role = '';
  @Input() url: string | null = null;

  private readonly storeResetService = inject(StoreResetService);
  private readonly authStore = inject(AuthStore);
  protected readonly themeService = inject(ThemeService);

  constructor(private router: Router) { }

  get initials() {
    return getInitials(this.name);
  }

  resetSelections() {
    this.storeResetService.resetAllSelections();
    (document.activeElement as HTMLElement | null)?.blur();
  }

  logout() {
    // Implement logout logic here
    this.authStore.clearAuth();
    // You might want to redirect to a login page or clear user session
    this.router.navigate(['/login']);
  }

}
